import React, { useState, useEffect } from "react";
import ProgressBar from "./ProgressBar";
import Countdown from "./Countdown";
import WeekSection from "./WeekSection";
import TRAINING_PLAN from "../data/trainingPlan";
import { WEEK_LABELS, WEEK_RANGES } from "../data/constants";

const STORAGE_KEY = "plan10k_checked";

function loadChecked() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    return saved ? JSON.parse(saved) : {};
  } catch {
    return {};
  }
}

export default function PlanTracker() {
  const [expanded, setExpanded] = useState(null);
  const [checked, setChecked] = useState(loadChecked);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(checked));
  }, [checked]);

  const toggleExpand = (idx) => setExpanded(expanded === idx ? null : idx);
  const toggleCheck = (idx) => setChecked((prev) => ({ ...prev, [idx]: !prev[idx] }));

  const completedCount = Object.values(checked).filter(Boolean).length;

  return (
    <div
      style={{
        fontFamily: "'Outfit', sans-serif",
        maxWidth: 720,
        margin: "0 auto",
        padding: "24px 12px",
        background: "transparent",
      }}
    >
      <div style={{ textAlign: "center", marginBottom: 32 }}>
        <div
          style={{
            fontSize: 13,
            fontWeight: 600,
            letterSpacing: 3,
            color: "#10B981",
            textTransform: "uppercase",
            marginBottom: 4,
          }}
        >
          Plan de entrenamiento
        </div>
        <h1 style={{ fontSize: 36, fontWeight: 800, margin: "4px 0", color: "var(--text-color, #111)" }}>
          10K en 17 días
        </h1>
        <p style={{ color: "var(--text-color-secondary, #6B7280)", fontSize: 14, margin: "0 0 4px 0" }}>
          15 de mayo → 31 de mayo 2026 · Objetivo: 38-48 min
        </p>
      </div>

      <Countdown />

      <ProgressBar completed={completedCount} total={TRAINING_PLAN.length} />

      {WEEK_RANGES.map((range, weekIdx) => (
        <WeekSection
          key={weekIdx}
          label={WEEK_LABELS[weekIdx]}
          days={TRAINING_PLAN.slice(range.start, range.end)}
          startIndex={range.start}
          expandedIndex={expanded}
          checkedMap={checked}
          onToggle={toggleExpand}
          onCheck={toggleCheck}
        />
      ))}

      <div
        style={{
          marginTop: 12,
          padding: 20,
          borderRadius: 16,
          background: "linear-gradient(135deg, #ECFDF5, #E0F2FE)",
          border: "1px solid #A7F3D0",
        }}
      >
        <div style={{ fontSize: 14, fontWeight: 700, color: "#065F46", marginBottom: 8 }}>
          🔑 Claves del éxito
        </div>
        <div style={{ fontSize: 12, color: "#047857", lineHeight: 1.7 }}>
          <b>Objetivo:</b> 10K entre 38 y 48 minutos (ritmo 3:48-4:48 min/km).<br />
          <b>Hidratación:</b> 2-3 litros de agua al día, más en días de carrera.<br />
          <b>Alimentación:</b> Carbohidratos complejos antes de correr, proteína después.<br />
          <b>Sueño:</b> Mínimo 7 horas. Tu cuerpo se repara mientras duermes.<br />
          <b>Calzado:</b> Usa tenis para correr con buen soporte. No estrenes el día de la carrera.<br />
          <b>Escucha tu cuerpo:</b> Si sientes dolor agudo, descansa. Molestia muscular leve es normal.
        </div>
      </div>
    </div>
  );
}
